import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  Checkbox,
  Collapse,
  TableCell,
  TableRow,
} from "@material-ui/core";
import React, { useCallback, useContext, useState } from "react";
import { Expand } from "../action-columns";
import { SELECT, UNSELECT } from "../state";
import { TableContext } from "../table";
import { ActionColumn } from "../tableWrapper";
import { RowWrapper } from "../types";

interface Props {
  onClick: (row: RowWrapper<any>) => void;
  wrapper: RowWrapper<any>;
  onSelected?: (row: any, selected: boolean) => void;
  onRemove?: (row: any) => void;
  actions: ActionColumn[];
}

export const RowComponent: React.FC<Props> = ({
  onClick,
  wrapper,
  onSelected,
  onRemove,
  actions,
}) => {
  const { state, dispatch } = useContext(TableContext);
  const { selectedRows } = state;
  const [expand, setExpand] = useState<boolean>(false);

  const isExpandable = actions.find((action) => action === "EXPAND");
  let expandableCol = isExpandable ? wrapper.row.cells.length + 1 : 1;

  const isEditable = actions.find((action) => action === "EDIT");
  expandableCol = isEditable ? expandableCol + 1 : expandableCol;

  const isRemovable = actions.find((action) => action === "REMOVE");
  expandableCol = isRemovable ? expandableCol + 1 : expandableCol;

  const isSelectable = actions.find((action) => action === "SELECT");

  !!isSelectable && expandableCol++;

  const isSelected = useCallback(
    (id: number): boolean => {
      return !!selectedRows[id];
    },
    [selectedRows]
  );

  const getRowCells = useCallback(() => {
    let cells = [];
    if (!!isSelectable) {
      cells.push(
        <TableCell key={0}>
          <Checkbox
            checked={isSelected(wrapper.id)}
            color="primary"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const isChecked = event.target.checked;
              !!isChecked
                ? dispatch({ type: SELECT, row: wrapper })
                : dispatch({ type: UNSELECT, row: wrapper });
              !!onSelected && onSelected(wrapper, event.target.checked);
            }}
          />
        </TableCell>
      );
    }

    cells = [
      ...cells,
      wrapper.row.cells.map((cell, index) => (
        <TableCell
          key={index + 1}
          onClick={cell.onClick}
          style={{ color: cell.color, cursor: cell.cursor }}
        >
          {cell.data}
        </TableCell>
      )),
    ];

    if (isEditable) {
      //TODO: add edit
    }

    if (isRemovable) {
      cells.push(
        <TableCell key={0} align="center">
          <FontAwesomeIcon
            icon={faTrash}
            color="primary"
            onClick={() => {
              !!onRemove && onRemove(wrapper);
            }}
          />
        </TableCell>
      );
    }

    if (isExpandable) {
      cells.push(
        <TableCell key={wrapper.row.cells.length + 3}>
          <Expand onClick={(expand: boolean) => setExpand(expand)} />
        </TableCell>
      );
    }

    return cells;
  }, [
    isSelectable,
    wrapper,
    isEditable,
    isRemovable,
    isExpandable,
    isSelected,
    dispatch,
    onSelected,
    onRemove,
  ]);

  return (
    <React.Fragment>
      <TableRow hover onClick={(event: any) => onClick(wrapper)} tabIndex={-1}>
        {getRowCells()}
      </TableRow>
      {isExpandable ? (
        <TableRow>
          <TableCell
            colSpan={expandableCol}
            style={{
              paddingBottom: 0,
              paddingTop: 0,
              border: "none",
              backgroundColor: "#f0f0f0",
            }}
          >
            <Collapse in={expand} timeout="auto" unmountOnExit>
              <Box m={2}>
                {wrapper.row.expandableContent
                  ? wrapper.row.expandableContent
                  : "NOTHING TO SEE"}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      ) : null}
    </React.Fragment>
  );
};
